import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Form, FormText } from 'react-bootstrap';
import TextInput from '../inputs/TextInput';
import WithTranslation from '../../../hocs/WithTranslation';

class BasicText extends Component {
    static propTypes = {
        className: PropTypes.string,
        description: PropTypes.string,
        disabled: PropTypes.bool,
        displayHelp: PropTypes.bool,
        input: PropTypes.object.isRequired,
        inputClassName: PropTypes.string,
        label: PropTypes.string,
        icon: PropTypes.string,
        maxLength: PropTypes.string,
        meta: PropTypes.object.isRequired,
        placeholder: PropTypes.string,
        placeholderIcon: PropTypes.string,
        required: PropTypes.bool,
        styleProps: PropTypes.object,
        type: PropTypes.string,
        prefix: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    };

    getGroupClassName = () => {
        const { required, className, icon } = this.props;
        return cns(className, {
            required,
            hasIcon: icon
        });
    };

    getFeedbackMessage = () => {
        const { error, warning, valid, initial } = this.props.meta;
        const { value } = this.props.input;

        let message = '';
        if (!valid) {
            if (error) {
                message = error;
            } else if (warning) {
                message = warning;
            }
        }

        if (value && value !== initial && !valid && error) {
            message = error;
        }
        return message;
    };

    getValidationState = () => {
        const { error, warning, valid } = this.props.meta;
        if (!valid && error) {
            return 'error';
        }
        if (!valid && warning) {
            return 'warning';
        }
        return null;
    };

    render() {
        const {
            label,
            description,
            input: { name, value, onChange },
            placeholder,
            icon,
            required = false,
            type = 'text',
            disabled = false,
            displayHelp = true,
            inputClassName = '',
            styleProps = {},
            maxLength,
            placeholderIcon,
            prefix = null
        } = this.props;
        const { horizontal = false, inputStyle = {} } = styleProps;
        let labelSection = null;
        if (label || description) {
            labelSection = (
                <div className={horizontal ? 'col-12 col-sm-6 no-padding' : ''}>
                    <div className={horizontal ? 'col-12 col-sm-10 no-padding' : ''}>
                        <label htmlFor={name} className={horizontal ? 'form-label' : ''}>
                            {label}
                            {required && <span className={'required-tag'}>*</span>}
                        </label>
                        <p className={horizontal ? 'form-description' : ''}> {description} </p>
                    </div>
                </div>
            );
        }

        let helpBlockSection = null;
        const validationMessage = this.getValidationState();
        const newStyleProps = { ...inputStyle };

        if (displayHelp) {
            newStyleProps[validationMessage] = true;
            helpBlockSection = <FormText className={validationMessage}>{this.getFeedbackMessage()}</FormText>;
        }
        return (
            <Form.Group className={this.getGroupClassName()} validated={this.getValidationState()}>
                {labelSection}
                {prefix}
                <div className={cns('basic-text', inputClassName, { 'with-icon': placeholderIcon })}>
                    <i className={placeholderIcon} />
                    <TextInput
                        onChange={onChange}
                        value={value}
                        disabled={disabled}
                        required={required}
                        placeholder={placeholder}
                        maxLength={maxLength}
                        type={type}
                        name={name}
                        styleProps={newStyleProps}
                        className={'text-input'}
                    />
                    {helpBlockSection}
                </div>
                {icon ? <i className={icon} /> : null}
            </Form.Group>
        );
    }
}

export const BasicTextComponent = BasicText;
export default WithTranslation(BasicText);
